import React, { useState } from 'react';
import styled from 'styled-components';
import AngleDownIcon from '@clasohlson/co-ui-components/Icons/AngleDownIcon';

const ExpandWrapper = styled.div<WrapperProps>`
  background: ${({ theme }) => theme.colors.lightGray};
  padding: 0;
  /* border-style: solid;
  border-width: 1px;
  border-color: ${({ isOpen, theme }) =>
    isOpen ? theme.colors.primary : theme.colors.mediumGray}; */
  @media screen and (min-width: 640px) {
    padding: 34px 3rem;
    border-color: transparent;
    margin: 0;
  }
`;

const Title = styled.div<WrapperProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem 1rem;
  // background: ${({ theme, isOpen }) => (isOpen ? theme.colors.primary : 'transparent')};
  > svg {
    margin-right: 1rem;
    width: 36px;
    height: 36px;
    path {
      fill: #000;
    }
  }
  h4,
  .h4 {
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme, isOpen }) => theme.colors.text};
    font-size: 14px;
  }
  @media screen and (min-width: 640px) {
    padding: 0;
    flex-direction: column;
    justify-content: center;
    color: ${({ theme }) => theme.colors.text};
    background: transparent;
    > svg {
      margin: 0 0 1rem 0;
      width: 48px;
      height: 48px;
      path {
        fill: #000;
      }
    }
    h4,
    .h4 {
      color: ${({ theme }) => theme.colors.text};
      text-align: center;
      margin-bottom: 0.5rem;
      font-size: 21px;
      line-height: 1.86;
    }
  }
`;

const StyledIcon = styled.div<WrapperProps>`
  display: inline-flex;
  justify-self: flex-end;
  margin-left: auto;
  svg path {
    fill: #000;
  }
  svg {
    transition: all 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  }
  @media screen and (min-width: 640px) {
    flex-direction: none;
    display: none;
  }
`;

const ExpandContent = styled.div<WrapperProps>`
  transition: all 0.3s ease;
  overflow: hidden;
  max-height: ${({ isOpen }) => (isOpen ? '40rem' : '0')};
  p {
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.42;
    letter-spacing: normal;
    text-align: center;
    margin-top: 0;
    margin-bottom: 20px;
  }
  > div {
    padding: 1rem;
  }
  @media screen and (min-width: 640px) {
    max-height: none;
    overflow: visible;
    > div {
      padding: 0 1rem;
    }
    p {
      margin-bottom: 41px;
      font-size: 12px;
    }
  }
`;

interface Props {
  image: any;
  title: string;
  defaultOpen?: boolean;
}

interface WrapperProps {
  isOpen: boolean;
}

export const ExpandBox: React.FC<Props> = ({ image, title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);
  return (
    <ExpandWrapper isOpen={isOpen}>
      <Title isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        {image}
        <h4>{title}</h4>
        <StyledIcon isOpen={isOpen}>
          <AngleDownIcon fontSize="16" />
        </StyledIcon>
      </Title>
      <ExpandContent isOpen={isOpen}>
        <div>{children}</div>
      </ExpandContent>
    </ExpandWrapper>
  );
};
